/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostPersonsAnonymous201ResponseAllOf
 */
export interface PostPersonsAnonymous201ResponseAllOf {
    /**
     * 
     * @type {string}
     * @memberof PostPersonsAnonymous201ResponseAllOf
     */
    result: string;
}

/**
 * Check if a given object implements the PostPersonsAnonymous201ResponseAllOf interface.
 */
export function instanceOfPostPersonsAnonymous201ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function PostPersonsAnonymous201ResponseAllOfFromJSON(json: any): PostPersonsAnonymous201ResponseAllOf {
    return PostPersonsAnonymous201ResponseAllOfFromJSONTyped(json, false);
}

export function PostPersonsAnonymous201ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPersonsAnonymous201ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': json['result'],
    };
}

export function PostPersonsAnonymous201ResponseAllOfToJSON(value?: PostPersonsAnonymous201ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': value.result,
    };
}

